// Per-contract edit-state persistence helpers used by every
// /contract_YYYY_YYYY-show page and its paired AdminContractPaidEdit
// subcomponent. The same drafts cover students reached through the
// /dropped_* and /inactive_* lists since those pages route into the
// same contract show views.

const PREFIX = "contract-show.draft";

function key(year, id, kind) {
  return `${PREFIX}.${year}.${id}.${kind}`;
}

export function saveDraft(year, id, application) {
  if (!id) return;
  try {
    localStorage.setItem(key(year, id, "app"), JSON.stringify(application));
  } catch (_) { /* quota / private mode — silent */ }
}

export function loadDraft(year, id) {
  if (!id) return null;
  let raw;
  try { raw = localStorage.getItem(key(year, id, "app")); } catch (_) { return null; }
  if (!raw) return null;
  try { return JSON.parse(raw); } catch (_) { return null; }
}

export function saveTab(year, id, tab) {
  if (!id) return;
  try {
    localStorage.setItem(key(year, id, "tab"), String(tab ?? ""));
  } catch (_) { /* ignore */ }
}

export function loadTab(year, id) {
  if (!id) return null;
  try { return localStorage.getItem(key(year, id, "tab")); } catch (_) { return null; }
}

export function clearDraft(year, id) {
  if (!id) return;
  try {
    localStorage.removeItem(key(year, id, "app"));
    localStorage.removeItem(key(year, id, "tab"));
  } catch (_) { /* ignore */ }
}
